Ext.ns('mx.comp.meta');

mx.comp.meta.CheckBox = Ext.extend(Ext.form.Checkbox, {
    attributeName: null,
    checked: false,
    labelSeparator: '',
    initComponent: function() {
        if (this.attributeName != null) {
            if (!this.plugins) {
                this.plugins = [];
            }

            this.plugins.push(new mx.plugin.metadataDrivenField(this.attributeName));
            this.plugins.push(new mx.plugin.hideableField());
            this.plugins.push(new mx.plugin.dynamicAllowBlank());

            this.allowBlank = false; // mx-form layout requires this to render "asterisk" element near label
        }
        mx.comp.meta.CheckBox.superclass.initComponent.call(this);
    },
});
